import React from "react";
import { Link } from "react-router-dom";
import Career_01 from '../../../assets/images/svg/job-location.svg';
import Career_02 from '../../../assets/images/svg/job-timeng.svg';

const Careers = () => {
  return (
    <div className="careers-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 m-auto">
            <div className="heading-box text-center">
              <span
                className="sub-title animate fadeInUp wow animated"
                data-wow-duration="1500ms"
              >
                Join our big family
              </span>
              <h2
                className="heading-title animate fadeInUp wow animated"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                We value the ideas, talent, and the voices of our people!
              </h2>
            </div>
          </div>
        </div>
        <div className="row gutter-y-30 gutter-x-15">
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="200ms"
            >
              <div className="job-box-heading">
                <h4>Chief Executive Officer</h4>
                <span className="post-name">Financial Advisory</span>
              </div>
              <p>
                we are a renowned global consulting firm committed to collaborating
                with business and societal leaders in overcoming their most critical
                challenges and seizing their greatest opportunities.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="400ms"
            >
              <div className="job-box-heading">
                <h4>Financial Analyst</h4>
                <span className="post-name">Client Relations</span>
              </div>
              <p>
                Quisque consectetur purus ut suscipit faucibus. Sed at ornare
                ligula. Quisque dignissim justo arcu, ut viverra elit venenatis,
                Pellentesque leo eros, sollicitudin vel lacinia non, vehicula at
                diam.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="600ms"
            >
              <div className="job-box-heading">
                <h4>Client Manager</h4>
                <span className="post-name">Client Relations</span>
              </div>
              <p>
                We have highly skilled engineers with excellent technical knowledge
                and experience in using the latest software standards. We have built
                a large pool of knowledge that we apply to deliver solutions that
                meet client’s needs, expectations and budget.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="800ms"
            >
              <div className="job-box-heading">
                <h4>Strategy Analyst</h4>
                <span className="post-name">Strategy Analyst</span>
              </div>
              <p>
                Conduct financial assessments, create forecasting models, and
                identify opportunities for cost reduction and revenue growth. Assist
                clients in making informed financial decisions and achieving
                long-term financial stability.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div >
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="1000ms"
            >
              <div className="job-box-heading">
                <h4>Designer</h4>
                <span className="post-name">Strategy Analyst</span>
              </div>
              <p>
                Financial assessments, create forecasting models, and identify
                opportunities for cost reduction and revenue growth. Assist clients
                in making informed financial decisions and achieving long-term
                financial stability.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div >
          <div className="col-lg-6">
            <div
              className="job-box animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="1200ms"
            >
              <div className="job-box-heading">
                <h4>Developer</h4>
                <span className="post-name">Development</span>
              </div>
              <p>
                Reduction Conduct financial assessments, create forecasting models,
                and identify opportunities for cost reduction and revenue growth.
                Assist clients in making informed financial decisions and achieving
                long-term financial stability.
              </p>
              <div className="job-lower">
                <Link to="/Contact" className="btn btn-light btn-theme">
                  Apply Now
                </Link>
                <ul className="job-location">
                  <li>
                    <img src={Career_01} alt="icon" />
                    <p>New York</p>
                  </li>
                  <li>
                    <img src={Career_02} alt="icon" />
                    <p>Full Time</p>
                  </li>
                </ul>
              </div>
            </div>
          </div >
          <div className="col-12">
            <div
              className="pagination animate fadeInUp wow animated"
              data-wow-duration="1500ms"
              data-wow-delay="1400ms"
            >
              <div className="blog-pagination-btn active">
                <Link to="#">1</Link>
              </div>
              <div className="blog-pagination-btn">
                <Link to="#">2</Link>
              </div>
              <div className="blog-pagination-btn">
                <Link to="#">
                  <i className="fa-solid fa-chevron-right" />
                </Link>
              </div >
            </div >
          </div >
        </div >
      </div >
    </div >

  )
}
export default Careers;